import { render, staticRenderFns } from "./TypePropertyDetail.vue?vue&type=template&id=137e468c&scoped=true"
import script from "./TypePropertyDetail.vue?vue&type=script&lang=js"
export * from "./TypePropertyDetail.vue?vue&type=script&lang=js"
import style0 from "./TypePropertyDetail.vue?vue&type=style&index=0&id=137e468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e468c",
  null
  
)

export default component.exports